import { useFundingWatcher } from '../store/watchers/useFundingWatcher';

export const FundingWatcher = () => {
  useFundingWatcher();
  return null;
};
